import { type ErrorComponentProps } from "@tanstack/react-router";

import styles from "./ErrorBoundary.module.css";
import { ErrorFallback } from "./ErrorFallback";

import { PageLayout } from "@/components/organisms/PageLayout/PageLayout";

/**
 * Default `errorComponent` for routes with no parent-mounted frame:
 * wraps the fallback in its own `PageLayout` (full viewport).
 */
export const RouteErrorComponent = (props: ErrorComponentProps) => (
  <PageLayout>
    <div className={styles.fallback}>
      <ErrorFallback {...props} />
    </div>
  </PageLayout>
);
